import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useNavbar } from '../../../hooks/use-navbar';
import { faroLogger } from '../../../observability/faro-logger';

const DEMO_SEEN_KEY = 'agent_demo_seen';

const DemoPage: FC = () => {
  const navbar = useNavbar();
  const navigate = useNavigate();

  useEffect(() => {
    if (navbar) {
      navbar.setTitle('Démo & règles');
      navbar.setBackArrow(true);
      navbar.setOnBack(() => {
        navigate(-1);
      });
      navbar.setRight();
    }
    try {
      localStorage.setItem(DEMO_SEEN_KEY, String(Date.now()));
    } catch (e) {
      /* noop */
    }
    faroLogger.info('demo_opened');
  }, [navbar]);

  return (
    <iframe
      src="/demo-agent.html?embed=1"
      title="Démo App Agent"
      style={{
        border: 0,
        width: '100%',
        height: '100%',
        display: 'block',
        background: '#0B1628',
      }}
    />
  );
};

export default DemoPage;
